










import { Component, Mixins } from "vue-property-decorator";
import DepartmentComboBoxSelector from "../../../../department/selectors/DepartmentComboBoxSelector.vue";
import { DepartmentUserFilterableMixin } from "../../mixins";

@Component({
  components: {
    DepartmentComboBoxSelector,
  },
})
export default class DepartmentListUserFilter extends Mixins(DepartmentUserFilterableMixin) {
}
